import {PureToggleableLeafRule} from "../../slate/html/Html";
import {DeserializedLeafRule} from "../../slate/Transformation";
import React from "react";

export const Rules: {[key: string]: DeserializedLeafRule<HTMLElement>} = {
    "emphasized": PureToggleableLeafRule({
        leaf: 'em'
    })
}